import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';
import { UserView } from './UserView';

export interface TaskUserViewRow {
  institution_id: number;
  user_id: string;
  pending_task_count: number;
  active_task_count: number;
  completed_task_count: number;
  completed_percentage: string;
}

export const TaskUserView: Entity<TaskUserViewRow> = {
  id: 'TaskUserView',
  title: 'Task User',
  service: 'main',
  rowLabel: (row: TaskUserViewRow) => row.user_id,
  primaryKeyFields: ['user_id'],
  source: {
    tableName: 'public.task_user_view',
  },
  defaultSort: [['user_id', 'ASC']],
  security: [
    { role: 'admin', action: 'read', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'read', access: 'all' },
  ],
  fields: {
    institution_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
    },
    user_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'User',
      listColumn: true,
      refEntity: UserView,
    },
    pending_task_count: {
      seq: 15,
      type: FieldType.Integer,
      label: 'Pending Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    active_task_count: {
      seq: 20,
      type: FieldType.Integer,
      label: 'Active Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_task_count: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Completed Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_percentage: {
      seq: 30,
      type: FieldType.Text,
      label: 'Completed Percentage',
      listColumn: true,
      fieldGroup: 'summary',
      listColumnAlign: 'right',
      persistence: PersistenceType.FrontEndOnly,
      evaluateFrontEndIn: (row: TaskUserViewRow) => {
        const denominator = row.pending_task_count + row.active_task_count + row.completed_task_count;
        return denominator === 0 ? '-' : ((row.completed_task_count / denominator) * 100).toFixed(0) + '%';
      },
    },
  },
};
